import React, { FC, ReactNode } from 'react';
import { Box, BoxProps, Grid, List, ListItem, VStack } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

interface TimelinePresentationPros extends BoxProps {
  title: string;
  description: string;
  steps: {
    title: string;
    description: string;
    icon: ReactNode;
    extraContent?: ReactNode;
  }[];
}

const TimelinePresentation: FC<TimelinePresentationPros> = ({
  description,
  steps,
  title,
  ...props
}) => (
  <Box {...props}>
    <Heading marginBottom="space-8">{title}</Heading>

    <Text marginBottom="space-32">{description}</Text>

    <VStack align="stretch" as={List} spacing="space-40">
      {steps.map((step) => (
        <Grid
          as={ListItem}
          gap="space-16"
          key={step.title}
          templateColumns="48px 1fr"
        >
          {step.icon}

          <Box textAlign="left">
            <Text
              fontWeight="weight-500"
              marginBottom="space-4"
              variant="primary"
            >
              {step.title}
            </Text>
            <Text marginBottom="space-12" variant="light">
              {step.description}
            </Text>

            {step.extraContent}
          </Box>
        </Grid>
      ))}
    </VStack>
  </Box>
);

export default TimelinePresentation;
